const ContentContainer = ({ children }) => {
  return (
    <div className="flex flex-col bg-slate-300 m-0 h-screen w-full overflow-auto md:px-10 xl:px-60">
      <div className="container">{children}</div>
    </div>
  )
}

export default ContentContainer
